
export default {
  props: {
    src: String,
    // Candidate list + slot description for responsive sources. `sizes` is
    // only emitted alongside a srcset — on its own it would be meaningless.
    srcset: String,
    sizes: String,
    alt: [String, Number],
    width: [String, Number],
    height: [String, Number],
    // `eager` covers two things at once: loading="eager", and the img--loaded
    // class that skips the opacity:0 placeholder. That placeholder matters more
    // than it looks — a transparent element is not an LCP candidate, so a card
    // left at opacity 0 until @load fires cannot register as the largest paint.
    eager: Boolean,

    // fetchpriority="high" is separate because it must go on exactly ONE image
    // per page; several high-priority images compete and none of them win.
    // Defaults to `eager` so existing call sites keep their current behaviour —
    // pass it explicitly to mark one image of an eager group as the LCP one.
    priority: { type: Boolean, default: null },
  },

  computed: {
    isPriority() {
      return this.priority === null ? this.eager : this.priority;
    },
  },

  mounted() {
    // Image may have finished loading before hydration attached @load
    // (cached or eager/high-priority) — never leave it at opacity: 0.
    const img = this.$refs.img;

    if (img && img.complete) {
      img.classList.remove("img--loading");
      img.classList.add("img--loaded");
    }
  },
};
